import { call, takeLatest } from "redux-saga/effects";
import { GET_APPROVAL_FLOW_LIST,GET_APPROVAL_FLOW_BY_ID,UPDATE_APPROVAL_FLOW,UPDATE_STAGES,UPDATE_DOCUMENTS,ADD_APPPROVAL_WORK_FLOW,ADD_DOCUMENTS,ADD_ORIGINATORS,ADD_STAGES,APPROVER_ACTION,GET_ALL_USERS_BY_ROLE_ID, GET_APPROVAL_ACCEPTANCE, GET_APPROVAL_LIST, GET_COLUMNS, GET_MAIN_MODULES, GET_SUB_MODULES } from "../types";
import { getApprovalFlowListApi,getApprovalFlowByIdApi,updateApprovalFlowApi,updateStagesApi,updateDocumentsApi,addApprovalWorkFlowApi,getAllUsersByRoleIdApi,addStagesApi,getApprovalListApi,getApprovalAcceptanceApi,approverActionApi,addOriginatorsApi, getMainModulesApi, getSubModulesApi, getColumnsApi,addDocumentsApi } from "../apis/approval-workflow-api";
export function* addApprovalWorkFlowWorker(action) {
  try {
    const res = yield call(addApprovalWorkFlowApi, action.data);

    if (res.data?.code === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getAllUsersByRoleIdWorker(action) {
  try {
    const res = yield call(getAllUsersByRoleIdApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addOriginatorsWorker(action) {
  try {
    const res = yield call(addOriginatorsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getMainModulesWorker(action) {
  try {
    const res = yield call(getMainModulesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getSubModulesWorker(action) {
  try {
    const res = yield call(getSubModulesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getColumnsWorker(action) {
  try {
    const res = yield call(getColumnsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addDocumentsWorker(action) {
  try {
    const res = yield call(addDocumentsApi, action.data);
    if (res.status === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addStagesWorker(action) {
  try {
    const res = yield call(addStagesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getApprovalListWorker(action) {
  try {
    const res = yield call(getApprovalListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getApprovalAcceptanceWorker(action) {
  try {
    const res = yield call(getApprovalAcceptanceApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* approverActionWorker(action) {
  try {
    const res = yield call(approverActionApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addApprovalWorkFlowWatcher() {
  yield takeLatest(ADD_APPPROVAL_WORK_FLOW, addApprovalWorkFlowWorker);
}
export function* getAllUsersByRoleIdWatcher() {
  yield takeLatest(GET_ALL_USERS_BY_ROLE_ID, getAllUsersByRoleIdWorker);
}
export function* addOriginatorsWatcher() {
  yield takeLatest(ADD_ORIGINATORS, addOriginatorsWorker);
}
export function* getMainModulesWatcher() {
  yield takeLatest(GET_MAIN_MODULES, getMainModulesWorker);
}
export function* getSubModulesWatcher() {
  yield takeLatest(GET_SUB_MODULES, getSubModulesWorker);
}
export function* getColumnsWatcher() {
  yield takeLatest(GET_COLUMNS, getColumnsWorker);
}
export function* addDocumentsWatcher() {
  yield takeLatest(ADD_DOCUMENTS, addDocumentsWorker);
}
export function* addStagesWatcher() {
  yield takeLatest(ADD_STAGES, addStagesWorker);
}
export function* getApprovalListWatcher() {
  yield takeLatest(GET_APPROVAL_LIST, getApprovalListWorker);
}
export function* getApprovalAcceptanceWatcher() {
  yield takeLatest(GET_APPROVAL_ACCEPTANCE, getApprovalAcceptanceWorker);
}
export function* approverActionWatcher() {
  yield takeLatest(APPROVER_ACTION, approverActionWorker);
}
export function* getApprovalFlowByIdWorker(action) {
  try {
    const res = yield call(getApprovalFlowByIdApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* updateApprovalFlowWorker(action) {
  try {
    const res = yield call(updateApprovalFlowApi, action.data);
    // The API answers 200 with { status: false } on failure, so the body has to
    // be checked too or a failed update reports success.
    if (res.status === 200 && res.data?.status !== false) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* updateStagesWorker(action) {
  try {
    const res = yield call(updateStagesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* updateDocumentsWorker(action) {
  try {
    const res = yield call(updateDocumentsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* getApprovalFlowByIdWatcher() {
  yield takeLatest(GET_APPROVAL_FLOW_BY_ID, getApprovalFlowByIdWorker);
}
export function* updateApprovalFlowWatcher() {
  yield takeLatest(UPDATE_APPROVAL_FLOW, updateApprovalFlowWorker);
}
export function* updateStagesWatcher() {
  yield takeLatest(UPDATE_STAGES, updateStagesWorker);
}
export function* updateDocumentsWatcher() {
  yield takeLatest(UPDATE_DOCUMENTS, updateDocumentsWorker);
}

export function* getApprovalFlowListWorker(action) {
  try {
    const res = yield call(getApprovalFlowListApi, action.data);
    if (res.status === 200 && res.data?.status !== false) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getApprovalFlowListWatcher() {
  yield takeLatest(GET_APPROVAL_FLOW_LIST, getApprovalFlowListWorker);
}
